import { render, staticRenderFns } from "./supply-add.vue?vue&type=template&id=3489a026&scoped=true&"
import script from "./supply-add.vue?vue&type=script&lang=js&"
export * from "./supply-add.vue?vue&type=script&lang=js&"
import style0 from "./supply-add.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./supply-add.vue?vue&type=style&index=1&id=3489a026&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3489a026",
  null
  
)

export default component.exports